import { TaskParameterModel } from "@/components/task-parameter/models";
import { ResponseModel } from "@/models";
import { ITaskParameters } from "../ITaskParameters";
import ApiService from "@/api";
import { SendErrorNotification } from "../functions";
import UpsertTypeToNamespaceRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/task-type/request/UpsertTypeToNamespaceRequest";
import UpsertTypeToNamespaceItem from "@/api/Main/dataSource/api/projects/task/i-service/models/task-type/request/UpsertTypeToNamespaceItem";
import { GetListTaskTypeRequest } from "./GetListTaskTypeRequest";

/**Сервис для управления типами */
export class TaskTypesService implements ITaskParameters {
  /**Сервис для использования API */
  api = new ApiService();

  GetList(entityId: string): Promise<ResponseModel<TaskParameterModel[]>> {
    return new Promise<ResponseModel<TaskParameterModel[]>>(async (resolve) => {
      const result = new ResponseModel<TaskParameterModel[]>();

      await this.api.Main.TaskTypeListService.getListTaskTypeAsync(new GetListTaskTypeRequest({
        NamespaceId: entityId,
      }))
        .then((response) => {
          result.Value = response.Items.map(
            (x) =>
              new TaskParameterModel({
                Id: x.Id,
                Name: x.Name,
                Color: x.Color,
                IsDefault: x.IsDefault,
                InUse: x.InUse,
                Description: x.Description,
              }),
          );
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
  SetList(
    entityId: string,
    parameters: TaskParameterModel[],
  ): Promise<ResponseModel<TaskParameterModel[]>> {
    return new Promise<ResponseModel<TaskParameterModel[]>>(async (resolve) => {
      const result = new ResponseModel<TaskParameterModel[]>();

      await this.api.Main.TaskTypeSaveService.upsertTypeToNamespaceIdAsync(
        new UpsertTypeToNamespaceRequest({
          NamespaceId: entityId,
          Types: parameters.map(
            (x) =>
              new UpsertTypeToNamespaceItem({
                TypeId: x.Id as string,
                Name: x.Name,
                IsDefault: x.IsDefault,
                Color: x.Color,
                Description: x.Description,
              }),
          ),
        }),
      )
        .then((response) => {
          result.Value = response.map(
            (p) =>
              new TaskParameterModel({
                Id: p.TypeId,
                Name: p.Name,
                IsDefault: p.IsDefault,
                Color: p.Color,
                Description: p.Description,
              }),
          );
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
}
